import { Button } from '@/client/components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/client/components/ui/dialog';
import { DatePicker } from '@/client/components/ui/date-picker';
import { Label } from '@/client/components/ui/label';

interface SubmitDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  dateFrom: string;
  dateTo: string;
  onDateFromChange: (v: string) => void;
  onDateToChange: (v: string) => void;
  onSubmit: (e: React.FormEvent) => void;
  isPending: boolean;
  error: string | null;
}

export function SubmitDialog({
  open,
  onOpenChange,
  dateFrom,
  dateTo,
  onDateFromChange,
  onDateToChange,
  onSubmit,
  isPending,
  error,
}: SubmitDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Submit Timesheet</DialogTitle>
        </DialogHeader>
        <form onSubmit={onSubmit} className="space-y-4">
          <p className="text-sm text-muted-foreground">
            Submitted entries are locked and cannot be edited.
          </p>
          <div className="flex gap-3">
            <div className="flex-1 space-y-1.5">
              <Label htmlFor="sub-from">From</Label>
              <DatePicker
                id="sub-from"
                required
                value={dateFrom}
                max={dateTo || undefined}
                onChange={onDateFromChange}
              />
            </div>
            <div className="flex-1 space-y-1.5">
              <Label htmlFor="sub-to">To</Label>
              <DatePicker
                id="sub-to"
                required
                value={dateTo}
                min={dateFrom || undefined}
                onChange={onDateToChange}
              />
            </div>
          </div>
          {error && <p className="text-sm text-destructive">{error}</p>}
          <div className="flex justify-end gap-2">
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
              Cancel
            </Button>
            <Button type="submit" disabled={isPending}>
              {isPending ? 'Submitting…' : 'Submit'}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
